import React from 'react'

export default props => (
    <div>
        <h2>404</h2>
        <p>These aren't the 'droids you were looking for.</p>
    </div>
)